import axios from "axios";
import { IAuthentication } from "..";
import { IServiceResult, IUser } from "../../Models/Models";

export class AuthenticationAxios implements IAuthentication {
    public GetStatus(): Promise<IServiceResult<IUser>> {
        const promise = new Promise<IServiceResult<IUser>>((resolve, reject) => {
            axios.get<IServiceResult<IUser>>("/Authentication/Status", {}).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    public LoadUser(): Promise<IServiceResult<IUser>> {
        const promise = new Promise<IServiceResult<IUser>>((resolve, reject) => {
            axios.get<IServiceResult<IUser>>("/Authentication/User").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    public async GetUser(): Promise<IServiceResult<IUser>> {
        return null;
    }
}
